module.exports = __webpack_public_path__ + "static/media/social-github.5d29099f.svg";


//////////////////
// WEBPACK FOOTER
// ./src/img/icons/avatars/social-github.svg
// module id = 119
// module chunks = 0